import styled, { css } from 'styled-components'
import { StyledFABProps } from './FAB.types'

const sizeStyles = {
  mini: css`
    width: 40px;
    height: 40px;
  `,
  small: css`
    width: 48px;
    height: 48px;
  `,
  medium: css`
    width: 56px;
    height: 56px;
  `,
}

export const StyledFAB = styled.button<StyledFABProps>`
  background: ${({ theme }) => theme.colors.primary};
  color: white;
  border-radius: 50%;
  border: none;
  box-shadow: ${({ theme }) => theme.shadows.lg};
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;

  ${(props) => sizeStyles[props.$size]}

  &:hover:not(:disabled) {
    box-shadow: 0 6px 20px rgba(2, 148, 223, 0.4);
    transform: translateY(-2px);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.colors.border.focus};
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    box-shadow: ${({ theme }) => theme.shadows.md};
  }

  /* Ensure icons inside are properly styled */
  svg {
    stroke-width: 2.5;
  }
`
